module.exports = __webpack_public_path__ + "assets/img/elektrines-ant-fasado.26e1d7fa.webp";